//params for vbm and tbss
export function getparams(type) {
  let params = [];
  let pvalue = {
    title: 'P值阈值',
    text: 'P-Value',
    content: {
      type: 'list',
      child: [{
        title: '',
        text: 'P=0.05',
        value: '0.05',
        name: 'input_thresh',
        defaultCheck: true,
        type: 'radio'
      }, {
        title: '',
        text: 'P=0.01',
        value: '0.01',
        name: 'input_thresh',
        defaultCheck: false,
        type: 'radio'
      }, {
        title: '',
        text: 'P=0.001',
        value: '0.001',
        name: 'input_thresh',
        defaultCheck: false,
        type: 'radio'
      }]
    }
  };

  if (type === 'vbm') {
    params = [{
      title: '颅骨剥离',
      text: 'Skull Stripping',
      content: {
        type: 'list',
        child: [{
          title: '颅骨剥离（常规）',
          text: 'FSL BET',
          name: 'skull_stripping',
          value: '1',
          defaultCheck: true,
          type: 'radio'
        }, {
          title: '颅骨剥离（常规+去颈）',
          text: 'FSL BET (With Neck)',
          name: 'skull_stripping',
          value: '2',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '颅骨剥离（常规+去颈+去眼）',
          text: 'FSL BET (Remove Neck/Eyeball)',
          name: 'skull_stripping',
          value: '3',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '颅骨剥离（边缘检测）',
          text: 'BSE',
          name: 'skull_stripping',
          value: '4',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '颅骨剥离（时间长）',
          text: 'ANTs',
          name: 'skull_stripping',
          value: '5',
          defaultCheck: false,
          type: 'radio'
        }]
      }
    }, {
      title: '图像配准',
      text: 'Image Registration',
      content: {
        type: 'list',
        child: [{
          title: '非线性配准',
          text: 'Non-linear Registration',
          name: 'brain_template',
          value: '1',
          defaultCheck: true,
          type: 'radio'
        }, {
          title: '线性配准',
          text: 'Linear Registration',
          name: 'brain_template',
          value: '2',
          defaultCheck: false,
          type: 'radio'
        }]
      }
    },
      pvalue, {
      title: '统计分析方法',
      text: 'Permutation Test',
      content: {
        type: 'tabs',
        child: [{
          title: 'cluster矫正法（无阈值）',
          text: 'Threshold-Free Cluster Enhancement',
          name: 'statistics_method',
          value: '1',
          defaultCheck: false,
          type: 'radio',
          tabcontent: [{
            title: '高斯滤波平滑核大小（单位mm）',
            text: 'Gaussian Smoothing Kernel',
            input: [{
              value: '2',
              name: 'input_file[1]',
              defaultCheck: true,
              type: 'radio'
            }, {
              value: '3',
              name: 'input_file[1]',
              defaultCheck: false,
              type: 'radio'
            }, {
              value: '4',
              name: 'input_file[1]',
              defaultCheck: false,
              type: 'radio'
            }]
          }, {
            title: '置换检验次数',
            text: 'Number for Permutation Test',
            name: 'permutation_number[1]',
            value: '5000',
            type: 'number'
          }]
        }, {
          title: 'cluster矫正法（带阈值）',
          text: 'Cluster-based Thresholding',
          name: 'statistics_method',
          value: '2',
          defaultCheck: true,
          type: 'radio',
          tabcontent: [{
            title: '高斯滤波平滑核大小（单位mm）',
            text: 'Gaussian Smoothing Kernel',
            input: [{
              value: '2',
              name: 'input_file[2]',
              defaultCheck: false,
              type: 'radio'
            }, {
              value: '3',
              name: 'input_file[2]',
              defaultCheck: true,
              type: 'radio'
            }, {
              value: '4',
              name: 'input_file[2]',
              defaultCheck: false,
              type: 'radio'
            }]
          }, {
            title: '置换检验次数',
            text: 'Number for Permutation Test',
            name: 'permutation_number[2]',
            value: '5000',
            type: 'number'
          }, {
            title: 'cluster矫正阈值(决定cluster大小)',
            text: 'Threshold for the cluster-based correction',
            name: 'clusterbased_thresh[2]',
            value: '2.3',
            type: 'number'
          }]
        }]
      }
    }, {
      title: '脑图谱',
      text: 'Atlas',
      content: {
        type: 'list',
        child: [{
          title: '',
          text: 'Cerebellar Atlas in MNI152 space after normalization with FNIRT',
          name: 'template_index',
          value: '1',
          defaultCheck: true,
          type: 'radio'
        }, {
          title: '',
          text: 'Cerebellar Atlas in MNI152 space after normalization with FLIRT',
          name: 'template_index',
          value: '2',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '',
          text: 'Harvard-Oxford Atlas (Cortical and Subcortical)',
          name: 'template_index',
          value: '3',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '',
          text: 'JHU ICBM-DTI-81 White-Matter Labels',
          name: 'template_index',
          value: '4',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '',
          text: 'JHU White-Matter Tractography Atlas',
          name: 'template_index',
          value: '5',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '',
          text: 'Juelich Histological Atlas',
          name: 'template_index',
          value: '6',
          defaultCheck: false,
          type: 'radio'
        }, {
          title: '',
          text: 'MNI Structural Atlas',
          name: 'template_index',
          value: '7',
          defaultCheck: false,
          type: 'radio'
        }]
      }
    }
    ];
  }

  if (type === 'tbss') {
    params = [{
      title: 'FA脑模板',
      text: 'FA Template',
      content: {
        type: 'list',
        child: [{
          title: '标准FA脑模板',
          text: 'FMRIB58_FA Template',
          name: 'space_template',
          value: '1',
          defaultCheck: true,
          type: 'radio'
        }]
      }
    }, {
      title: 'FA纤维束骨架图模板',
      text: 'FA Skeleton Map Template',
      content: {
        type: 'list',
        child: [{
          title: '自适应脑骨架',
          text: 'Mean FA Skeleton Map Template',
          name: 'skeleton_map_template',
          value: '1',
          defaultCheck: true,
          type: 'radio'
        }, {
          title: '标准FA脑骨架',
          text: 'FMRIB58_FA Skeleton Map Template',
          name: 'skeleton_map_template',
          value: '2',
          defaultCheck: false,
          type: 'radio'
        }]
      }
    }, {
      title: 'FA纤维束骨架阈值',
      text: 'FA Skeleton Threshlod',
      content: {
        type: 'list',
        child: [{
          title: '',
          text: '自定义',
          name: 'skeleton_threshold',
          value: '0.2',
          type: 'number'
        }]
      }
    }, {
      title: '置换检验次数',
      text: 'Permutation Test Number',
      content: {
        type: 'list',
        child: [{
          title: '',
          text: '自定义',
          name: 'permutation_number',
          value: '5000',
          type: 'number'
        }]
      }
    },
      pvalue, {
      title: '脑图谱',
      text: 'Atlas',
      content: {
        type: 'list',
        child: [{
          title: '',
          text: 'JHU ICBM-DTI-81 White-Matter Labels',
          name: 'template_index',
          value: '1',
          defaultCheck: true,
          type: 'radio'
        }, {
          title: '',
          text: 'JHU White-Matter Tractography Atlas',
          name: 'template_index',
          value: '2',
          defaultCheck: false,
          type: 'radio'
        }]
      }
    }
    ];
  }

  return params;

}


// WEBPACK FOOTER //
// ./src/apps/console/common/params.js